export default __webpack_public_path__ + "static/007-ff80bf7f1d3878c74743e51ab45574d4.jpg";